import JobTypeSelector from "../molecules/JobTypeSelector";
import { DateInput } from "@mantine/dates";
import FormField from "../molecules/FormField";
import Label from "../atom/Label";

const CareerFormOverview = ({ data = {}, onChange, errors = {} }) => {
  const handleInputChange = (key, value) => {
    if (key === "deadline") {
      const date = value instanceof Date ? value : new Date(value);
      onChange({ ...data, [key]: isNaN(date.getTime()) ? null : date });
    } else {
      onChange({ ...data, [key]: value });
    }
  };

  return (
    <form className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <JobTypeSelector
        value={data.jobType || ""}
        onChange={(val) => handleInputChange("jobType", val)}
      />

      <div>
        <FormField
          label="Reference Number"
          required
          placeholder="Enter reference number"
          value={data.referenceNumber || ""}
          onChange={(e) => handleInputChange("referenceNumber", e.target.value)}
        />
        {errors.referenceNumber && (
          <p className="mt-1 text-sm text-red-600">{errors.referenceNumber}</p>
        )}
      </div>

      <div>
        <FormField
          label="Region"
          required
          placeholder="Enter region"
          value={data.region || ""}
          onChange={(e) => handleInputChange("region", e.target.value)}
        />
        {errors.region && (
          <p className="mt-1 text-sm text-red-600">{errors.region}</p>
        )}
      </div>

      <div>
        <FormField
          label="Town/City"
          required
          placeholder="Enter city"
          value={data.city || ""}
          onChange={(e) => handleInputChange("city", e.target.value)}
        />
        {errors.city && (
          <p className="mt-1 text-sm text-red-600">{errors.city}</p>
        )}
      </div>

      <div>
        <FormField
          label="Organisation Name"
          required
          placeholder="Enter organisation"
          value={data.organization || ""}
          onChange={(e) => handleInputChange("organization", e.target.value)}
        />
        {errors.organisationName && (
          <p className="mt-1 text-sm text-red-600">{errors.organisationName}</p>
        )}
      </div>

      <div>
        <FormField
          label="Reports To:"
          required
          placeholder="Enter level"
          value={data.level || ""}
          onChange={(e) => handleInputChange("level", e.target.value)}
        />
        {errors.mtnLevel && (
          <p className="mt-1 text-sm text-red-600">{errors.mtnLevel}</p>
        )}
      </div>

      <div className="mb-4 col-span-full">
        <Label>
          Application Deadline <span className="text-red-500">*</span>
        </Label>
        <DateInput
          value={data.deadline || null}
          onChange={(val) => handleInputChange("deadline", val)}
          placeholder="Pick date"
          required
          valueFormat="DD/MM/YYYY"
          className="w-full"
        />
        {errors.applicationDeadline && (
          <p className="mt-1 text-sm text-red-600">
            {errors.applicationDeadline}
          </p>
        )}
      </div>

      <style>{`
        input:focus, select:focus, textarea:focus, [contenteditable="true"]:focus {
          outline: 2px solid #FFCC00;
          outline-offset: 0;
          box-shadow: 0 0 0 3px rgba(255, 204, 0, 0.35);
          border-color: #FFCC00 !important;
        }
      `}</style>
    </form>
  );
};

export default CareerFormOverview;
